export const availableTolerances = Array(50)
  .fill(0)
  .map((i, idx) => idx / 200 + 0.005)

export const toleranceToPercentageString = (value: number) => `${(value * 100).toFixed(2)} %`
